import locales from "./locales/locales";
import router from './routes/routes'

export const RegistrationsModule = {
	name: 'registrations',
	routes: router,
	locales: locales,
}